import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';

import { NeonRewardConfigs } from './NeonRewardConfigs/index.tsx';
import type { NeonRewards_anyRewardConfigInterface } from './__generated__/index.graphql.ts';

type Props = {
  anyRewardConfigInterfaces: NeonRewards_anyRewardConfigInterface[];
  verificationNeeded?: { phoneNumber: boolean; kyc: boolean };
} & Pick<
  ComponentProps<typeof NeonRewardConfigs>,
  | 'myCompletedThresholdsStreakTasksCount'
  | 'size'
  | 'iconSize'
  | 'displayLabels'
  | 'compact'
  | 'myCommonCompletedThresholdsStreakTasksCount'
>;

export const NeonRewards = ({
  anyRewardConfigInterfaces,
  verificationNeeded,
  ...rest
}: Props) => {
  return (
    <NeonRewardConfigs
      rewardConfigs={anyRewardConfigInterfaces}
      verificationNeeded={verificationNeeded}
      {...rest}
    />
  );
};

NeonRewards.fragments = {
  anyRewardConfigInterface: gql`
    fragment NeonRewards_anyRewardConfigInterface on AnyRewardConfigInterface {
      id
      ...NeonRewardConfigs_rewardConfig
    }
    ${NeonRewardConfigs.fragments.rewardConfig}
  ` as TypedDocumentNode<NeonRewards_anyRewardConfigInterface>,
};
